var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iconHolder",class:(_vm.size) ? ("bm-" + _vm.size) : '',style:({
    'border-color' : _vm.circleColor,
    'color' : _vm.color
  })},[(!_vm.text && _vm.name)?_c('span',{class:'icon-' + _vm.name}):_vm._e(),_vm._v(" "),(_vm.text !== '')?_c('div',{staticClass:"iconHolder-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14310bd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/globalComponents/Icon.vue
// module id = plZ0
// module chunks = 0